/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */

// Miscellaneous items that haven't been properly integrated into the branding.
export const backgroundColorTerm = "#333333";
export const defaultCodeFontSizePt = 14;
export const topBarHeight = "4rem";
